<template>
  <div class="sidebar-nav-item col-xs-4 col-lg-12">
    <div class="nav-head" @click = refreshSidebarNavItem()>
      <router-link
        class="bold uppercase tab-nav"
        :class="item.gaTrackingClass"
        :to="{ name: item.path, params: item.params }"
        v-text="item.name"
      />
    </div>
    <slot :item="item">
      <ul
        v-if="item.children.length"
        class="links"
      >
        <li
          v-for="link in item.children"
          :key="link.id"
        >
          <router-link
            :class="link.gaTrackingClass"
            :to="{ name: link.path, params: link.params }"
            v-text="link.name"
          />
        </li>
      </ul>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'SidebarNavItem',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  methods: {
    refreshSidebarNavItem () {
      location.reload()
    }
  }
}
</script>

<style lang='scss' scoped>
.bold {
  @include font-weight-bold;
}

.uppercase {
  text-transform: uppercase;
}

.links {
  @include media-breakpoint-down(md) {
    display: none;
  }

  li {
    margin-top: 2px;
  }
}

.router-link-exact-active {
  color: $brand-primary;
}

.sidebar-nav-item {
  margin-bottom: 20px;

  @include media-breakpoint-down(md) {
    padding-left: 0;
    padding-right: 0;
  }
}

.nav-head {
  @include media-breakpoint-down(md) {
    margin-bottom: 0;

    a.router-link-exact-active {
      color: inherit;
      border-color: $brand-primary;
    }

    a {
      color: $grey-dark;
      padding: 10px 0px;
      display: inline-block;
      width: 100%;
      text-align: center;
      border-bottom: 3px solid $white;
      white-space: pre-wrap;
    }
  }
}

.col-xs-4 {
  display: inline-block;
}
</style>
